module.exports = __webpack_public_path__ + "img/trash.5afe155b.svg";